import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import ListItem from './BaseModuleListItem';
import {
  changeBaseModuleScreen,
  setCurrentModule,
  removeBaseModule,
} from '../../actions/baseModule';
import { getDefaultModuleList } from '../../selectors';
import i18n from '../../internationalization/i18n';

const propTypes = {
  changeBaseModuleScreen: PropTypes.func.isRequired,
  modulesList: PropTypes.array.isRequired,
  setCurrentModule: PropTypes.func.isRequired,
  removeBaseModule: PropTypes.func.isRequired,
};

const defaultProps = {};

class BaseModuleOverview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opened: false,
    };

    this.editModule = this.editModule.bind(this);
  }

  editModule(module) {
    this.props.setCurrentModule(module);
    this.props.changeBaseModuleScreen('edit');
  }

  render() {
    const { modulesList } = this.props;
    return (
      <div className="c-bb-basemodule">
        <div className="c-bb-basemodule-header">
          <div className="c-bb-basemodule-header-icon">
            <i className="icon-password" />
          </div>
          <h1 className="c-bb-basemodule-header-title">
            {i18n.t('CONTENT.baseModule')}
          </h1>
        </div>
        <div className="c-bb-basemodule-list">
          {modulesList.map(item => (
            <ListItem
              key={item.id}
              remove={this.props.removeBaseModule}
              module={item}
              editModule={this.editModule}
              removable
            />
          ))}
        </div>
        <i className="c-bb-basemodule-list__add icon-add" onClick={() => this.props.changeBaseModuleScreen('create')} />
      </div>);
  }
}

BaseModuleOverview.propTypes = propTypes;
BaseModuleOverview.defaultProps = defaultProps;

const mapStateToProps = state => ({
  isOpen: state.baseModule.isOpen,
  modulesList: getDefaultModuleList(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  changeBaseModuleScreen,
  setCurrentModule,
  removeBaseModule,
}, dispatch);

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(BaseModuleOverview));



// WEBPACK FOOTER //
// ./src/components/BaseModule/BaseModuleOverview.js